import { Checkbox, CheckboxSelect, SelectDropDown, Tooltip, Typography } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { t } from "i18next"

import { transcriptTranslationModel } from "../../models"
import { useInterrelatedOptions } from "./transcript-translation-settings.hooks"

import styles from "./transcript-translation-settings.module.pcss"

export const TranscriptTranslationSettings = () => {
  const formValue = useUnit(transcriptTranslationModel.$formValue)

  const actions = useUnit({ handleChange: transcriptTranslationModel.handleChange })

  const { optionsFrom, optionsTo } = useInterrelatedOptions()

  return (
    <div className={styles.container}>
      <Typography.Body1>{t("userProfile_userProfileSidePanel_translation_title")}</Typography.Body1>
      <div className={styles.checkbox}>
        <Checkbox
          isValue={formValue.transcript_translation_enabled}
          onChange={(value) => actions.handleChange({ name: "transcript_translation_enabled", value })}
        >
          {t("userProfile_userProfileSidePanel_translation_checkboxLabel")}
        </Checkbox>
        <Tooltip.Icon
          alternativePosition="underLeft"
          title={t("userProfile_userProfileSidePanel_translation_tooltipInfo")}
        />
      </div>
      {formValue.transcript_translation_enabled && (
        <div className={styles.selectControls}>
          <div className={styles.selectWrapper}>
            <CheckboxSelect
              label={t("userProfile_userProfileSidePanel_translation_selectFromLabel")}
              options={optionsFrom}
              value={optionsFrom.filter((option) => formValue.translate_from_languages?.includes(option.value)) || []}
              isSortingDisabled
              onSelect={(value) =>
                actions.handleChange({
                  name: "translate_from_languages",
                  value: value.map(({ value }) => value).sort((a, b) => a.localeCompare(b) - b.localeCompare(a))
                })
              }
            />
          </div>
          <div className={styles.selectWrapper}>
            <SelectDropDown
              label={t("userProfile_userProfileSidePanel_translation_selectToLabel")}
              options={optionsTo}
              value={optionsTo.find((option) => option.value === formValue.translate_to_language)}
              onSelect={({ value }) => actions.handleChange({ name: "translate_to_language", value })}
              placeholder={t("component_component_checkboxSelectPromptLabel_selectLabel")}
            />
          </div>
        </div>
      )}
    </div>
  )
}
